import { render } from "./rn-ws-text.vue?vue&type=template&id=8e790dfc"
import script from "./rn-ws-text.vue?vue&type=script&lang=js"
export * from "./rn-ws-text.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__